export default __webpack_public_path__ + "static/media/seyi-report_w320.34083e7b.jpeg";